
import Request from "@/ts/Request";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ContactChoiceModal extends Vue {
  // Props
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Object, default: null }) storeContact!: any;

  // Data
  noSelectedStore = false;
  stores: Array<any> = [];
  selectedStore: any = null;

  // Computed
  get show() {
    return this.value;
  }
  set show(val) {
    this.$emit("input", val);
  }

  mounted() {
    this.getStores();
  }

  selectWhatsapp() {
    if (this.storeContact && this.storeContact.WHATSAPP) {
      window.open(`https://wa.me/${this.storeContact.WHATSAPP}`, "_blank");
    } else {
      this.noSelectedStore = true;
    }
  }

  sendWhatsapp() {
    if (this.selectedStore[0] && this.selectedStore[0].WHATSAPP) {
      window.open(`https://wa.me/${this.selectedStore[0].WHATSAPP}`, "_blank");
      this.noSelectedStore = false;
      this.closeModal();
    }
  }

  selectChat() {
    this.$router.push({ name: "SupportRequest" });
    this.closeModal();
  }

  closeModal() {
    this.show = false;
  }

  getStores() {
    try {
      const req = new Request();
      req.body = {
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "getStores";
      req.callbackSuccess = (response: any) => {
        this.stores = Array.isArray(response.stores)
          ? response.stores
          : [response.stores];
      };
      req.callbackError = (error: any) => {
        console.error("Erro ao buscar lojas:", error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.error("Erro em getStores:", e);
    }
  }
}
